import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=4dea4a4e&scoped=true&"
import script from "./SuccessMessage.vue?vue&type=script&lang=ts&"
export * from "./SuccessMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea4a4e",
  null
  
)

export default component.exports